import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { Image } from "element-ui";
import { objectToQuery } from "../../ObjectToQuery";

export enum BannerLinkType {
    NONE = "none",
    URL = "url",
    PRODUCT = "product",
    CATEGORY = "category"
}

export class GetTayehMarketplaceShopBannerResponse {
    image: Image;
    link_type: BannerLinkType;
    link: string;
}

export enum BannerSize {
    ALL = "all",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}

class getTyMarketplaceBannersQuery {
    size: BannerSize
}

export function getTyMarketplaceShopBanners(instance_username: string, params?: getTyMarketplaceBannersQuery): Promise<AxiosResponse<GetTayehMarketplaceShopBannerResponse[]>> {    
    const query = `/marketplace/${instance_username}/banners?${objectToQuery(params)}`;
    return Cirus.get(query);
}